import type { TableColumnsType } from 'ant-design-vue'

// 场景分类列
export const columns: TableColumnsType = [
  {
    title: '分类code',
    key: 'scenarioCode',
    dataIndex: 'scenarioCode',
    width: 130,
  },
  {
    title: '场景分类',
    key: 'scenarioName',
    dataIndex: 'scenarioName',
  },
]

// 场景管理列
export const configColumns: TableColumnsType = [
  {
    title: '场景code',
    key: 'subScenarioCode',
    dataIndex: 'subScenarioCode',
  },
  {
    title: '子场景名称',
    key: 'subScenarioName',
    dataIndex: 'subScenarioName',
  },
  {
    title: '所属分类',
    key: 'scenarioName',
    dataIndex: 'scenarioName',
  },
  // {
  //   title: '备注',
  //   key: 'remark',
  //   dataIndex: 'remark',
  // },
  // {
  //   title: '操作',
  //   key: 'handle',
  //   dataIndex: 'handle',
  //   align: 'right',
  // },
]

// 场景映射列
export const scenarioMap: Record<string, string> = {
  preOrder: '预下单',
  clientPay: '客户端支付',
  verifyOrder: '验单',
  pendingOrder: '补单',
  refund: '退款',
}
